(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["antd"] = factory(require("React"), require("ReactDOM"), require("jQuery"));
	else
		root["antd"] = factory(root["React"], root["ReactDOM"], root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_828__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition